import { render, staticRenderFns } from "./ticket_situation.vue?vue&type=template&id=42f5b434"
import script from "./ticket_situation.vue?vue&type=script&lang=js"
export * from "./ticket_situation.vue?vue&type=script&lang=js"
import style0 from "./ticket_situation.vue?vue&type=style&index=0&id=42f5b434&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports